import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { format } from "date-fns";

import routes from "../routes";
import colors from "../colors";
import { getAll, setSort, setPage } from "../offers/actions";
import BlockLoader from "../components/BlockLoader";
import { SiteTemplate } from "../components/Site";
import { Table } from "../components/Table";
import RowActions from "./RowActions";
import { replacePlaceholders } from "../lib/utils";
import AgencyCode from "components/AgencyCode";

class List extends Component {
  componentDidMount() {
    const { getAll } = this.props;

    getAll();
  }

  redirectToEdit = uid => {
    const { history } = this.props;
    history.push(replacePlaceholders(routes.offersEdit, { uid }));
  };

  render() {
    const {
      agencies,
      viewer,
      offers,
      setSort,
      setPage,
      params,
      result
    } = this.props;
    let i = 0;

    const ids = result && result.get("ids");

    const agency = agencies.get(viewer && viewer.agencyUID);

    const showInfo =
      agency && (!agency.get("name") || !agency.get("agencyUrl"));

    return (
      <SiteTemplate title="Oferty">
        {showInfo && (
          <Info>
            <Text>Uzupełnij dane agencji!</Text>
            <Link to={routes.settings}>Kliknij tutaj.</Link>
          </Info>
        )}
        <Actions>
          <AgencyCode />
          <StyledLink to={routes.offersAdd}>Dodaj</StyledLink>
        </Actions>
        <BlockLoader
          isLoading={!ids}
          isEmpty={ids && ids.length === 0}
          noRowsText="Brak dodanych ofert"
        >
          <Table
            setSort={setSort}
            setPage={setPage}
            params={params}
            meta={result && result.get("meta")}
            labels={[
              {
                title: "Lp."
              },
              {
                sortField: "title",
                sortType: "alpha",
                title: "Tytuł"
              },
              {
                sortField: "start_date",
                title: "Data rozpoczęcia"
              },
              {
                sortField: "city",
                sortType: "alpha",
                title: "Miasto"
              },
              {
                sortField: "code",
                sortType: "alpha",
                title: "Kod pocztowy"
              },
              {
                sortField: "sex",
                sortType: "alpha",
                title: "Płeć"
              },
              {
                sortField: "created_at",
                title: "Utworzono"
              },
              {
                title: ""
              }
            ]}
          >
            {ids &&
              ids.map(uid => {
                i += 1;
                const item = offers.get(uid);
                return (
                  <StyledTr
                    key={item.get("uid")}
                    onClick={() => this.redirectToEdit(uid)}
                  >
                    <td>
                      {(params.get("currentPage") - 1) * params.get("limit") +
                        i}
                    </td>
                    <td>{item.get("title")}</td>
                    <td>{format(item.get("startDate"), "DD.MM.YYYYr.")}</td>
                    <td>{item.get("city")}</td>
                    <td>{item.get("code")}</td>
                    <td>{item.get("sex")}</td>
                    <td>
                      {format(item.get("createdAt"), "HH:mm DD.MM.YYYYr.")}
                    </td>
                    <StyledTd>
                      <RowActions item={item} />
                    </StyledTd>
                  </StyledTr>
                );
              })}
          </Table>
        </BlockLoader>
      </SiteTemplate>
    );
  }
}

const StyledTr = styled.tr`
  cursor: pointer;
`;
const StyledTd = styled.td`
  padding: 0 !important;
`;

const Info = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.warning};
  color: white;
  padding: 15px 0px;
  margin-bottom: 10px;
`;
const Text = styled.div`
  margin-right: 5px;
`;
const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 20px;
`;

const StyledLink = styled(Link).attrs({
  className: "btn btn-xl btn-primary"
})``;

List = connect(
  state => ({
    offers: state.entities.get("offers"),
    agencies: state.entities.get("agencies"),
    viewer: state.auth.get("viewer"),
    params: state.offers.params.get("default"),
    result: state.offers.results.get("default")
  }),
  { getAll, setSort, setPage }
)(List);
List = withRouter(List);
export default List;



// WEBPACK FOOTER //
// ./src/offers/List.js